import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';

export const SalePage: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useLanguage();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>{t('menu.sale')}</h2>
      <p>Страница продажи товаров в разработке...</p>
    </div>
  );
};
